<template>
    <div>
      <v-card width="600" class="mx-auto mt-5">
        <div style="text-align:center;padding-top:10px">
            <h3 v-if="user.loggedIn">Edit profile</h3>
            <h3 v-else>Sign up</h3>
        </div>
        <v-card-text>
          <div v-if="error" class="alert alert-danger">{{error}}</div>
          <v-form ref="form">
            <template>
              <v-row class="ma-0 pa-0">
                <v-col
                  cols="12"
                  sm="2"
                  class="ma-0 pa-0"
                >       
                  <v-select             
                    :items="title_list"
                    placeholder="Title"
                    v-model="title"
                    dense
                    item-text="text"
                    item-value="value"
                    required
                    outlined
                    :rules="[v => !!v || 'Title is a required field']"
                    return-object
                    style="padding-right:5px;border-color:yellow-green"
                  >
                  </v-select> 
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  class="ma-0 pa-0"
                >       
                  <v-text-field
                    placeholder="First name"
                    v-model="user.data.first_name"
                    dense
                    required
                    outlined
                    :rules="[v => !!v || 'First name is a required field']"
                    style="padding-right:5px;padding-left:5px"
                  >  
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >             
                  <v-text-field
                    placeholder="Last name"
                    v-model="user.data.last_name"
                    :rules="[v => !!v || 'Last name is a required field']"
                    dense
                    outlined
                    required
                    style="padding-left:5px"
                  > 
                  </v-text-field>
                </v-col>       
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >  
                  <vue-phone-number-input 
                    v-model="phone_number" 
                    placeholder="Phone number"
                    default-country-code="ZM"
                    required
                    @update="getPhoneNumber"
                    no-example
                    style="padding-right:5px"
                  />
                </v-col>  
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        placeholder="Date of birth"
                        style="padding-left:5px"
                        outlined
                        dense
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="date"
                      no-title 
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1920-01-01"
                      @change="save"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >  
                  <v-autocomplete
                    v-model="nationality"
                    :items="country_list"
                    dense
                    outlined
                    placeholder="Nationality *"
                    required
                    item-text="name"
                    item-value="alpha3code"
                    return-object
                    style="padding-right:5px"
                    :rules="[v => !!v || 'Nationality is a required field']"
                  ></v-autocomplete>  
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  class="ma-0 pa-0"
                > 
                  <v-select             
                    :items="id_type_list"
                    placeholder="ID type"
                    v-model="user.data.id_type"
                    dense
                    item-text="text"
                    item-value="value"
                    return-object
                    outlined
                    required
                    style="padding-left:5px"
                    :rules="[v => !!v || 'ID type is a required field']"
                  >
                  </v-select> 
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  class="ma-0 pa-0"
                >  
                  <v-text-field
                    placeholder="ID number"
                    v-model="user.data.national_id"  
                    :rules="[v => !!v || 'ID number is a required field']"
                    dense
                    outlined
                    required
                    style="padding-left:5px;padding-right:5px"
                  >        
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >  
                  <v-select             
                    :items="gender_list"
                    placeholder="Gender"
                    v-model="user.data.gender"
                    dense
                    item-text="text"
                    item-value="value"
                    return-object
                    style="padding-right:5px"
                    outlined
                    required
                    :rules="[v => !!v || 'Gender is a required field']"
                  >
                  </v-select>   
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >  
                  <v-select             
                    :items="marital_status_list"
                    placeholder="Marital status"
                    v-model="user.data.marital_status"
                    dense
                    item-text="text"
                    item-value="value"
                    return-object
                    outlined
                    style="padding-left:5px"
                  >
                  </v-select>  
                </v-col>
              </v-row>
              <v-text-field
                label="Resdential address"
                v-model="user.data.residential_address"              
                dense
                outlined
              >    
              </v-text-field>
              <v-text-field
                placeholder="Email"
                v-model="user.data.email_address"
                :rules="[v => !!v || 'Email address is a required field']"
                dense
                required
                outlined
              >        
              </v-text-field>
              <v-text-field
                v-if="!user.loggedIn"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Password"
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :rules="[v => !!v || 'Password is a required field']"
                dense
                required
                outlined
              />
            </template>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <div style="text-align:center;padding:10px">
          <v-btn
            v-if="user.loggedIn"
            :loading="loading"
            color="primary"
            rounded
            block
            @click="submit"
          >
            Submit
          </v-btn>
          <v-btn
            v-else
            :loading="loading"
            color="primary"
            rounded
            block
            @click="submit"
          >
            Register
          </v-btn>
        </div>        
      </v-card> 
      <div v-if="!user.loggedIn" style="text-align:center;padding:5px">
        <p>
          Already Registered? 
          <router-link to="/login">
            Login here
          </router-link>
        </p>
      </div> 
    </div>
</template>
<script>
  import { mapGetters } from "vuex";
  
  import axios from "axios";

  const URL = "http://139.59.131.242:4000/user/register";
  const URL_EDIT = "http://139.59.131.242:4000/user/edit";

  export default {
    name: 'Register',
    data: () => ({
      date: null,
      menu: false,
      phone_number: '',
      showPassword: false,
      password: '',
      country_list: null,
      title: null,
      nationality: null,
      gender_list: [
        'Female',
        'Male',
        'Other'
      ],
      title_list: [
        { text:'Mr', value: 1 },
        { text:'Ms', value: 2 },
        { text:'Mrs',value: 3 },
        { text:'Dr',value: 4 },
        { text:'Prof',value: 5 }
      ],
      marital_status_list: [
        'MARRIED',
        'SINGLE',
        'DIVORCED',
        'WIDOWED'
      ],
      id_type_list: [
        'NRC',
        'PASSPORT',
        'DRIVERS LICENSE'
      ],
      loading: false,
      error: null
    }),
    methods: {
      save (date) {
        this.$refs.menu.save(date)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      submit() {      
        if (this.$refs.form.validate()){
          if (this.user.loggedIn){
            this.loading = true;

            var date_of_birth = this.formatDate(this.date);
            this.user.data.date_of_birth = dob;
            this.user.data.title = this.title.text;
            this.user.data.nationality = this.nationality.name;

            const client = {
              email: this.user.data.email_address,
              first_name: this.user.data.first_name,
              last_name: this.user.data.last_name,
              other_names: "",
              title: this.title.text,
              gender: this.user.data.gender,
              marital_status: this.user.data.marital_status,
              nationality: this.nationality.name,
              dob: date_of_birth,
              phone_number: this.user.data.phone_number,
              residential_address: this.user.data.residential_address, 
              password: this.password,
              agency_id: 40,
              documents: [
                {
                  document_id: this.user.data.national_id,
                  document_type: this.user.data.id_type
                }
              ]
            }
            console.log(this.user);
            axios
            .post(URL_EDIT, client)
            .then(response => {
              console.log(response);
              if (response.data.message == "success"){
                this.loading = false;
                this.$router.push('/dashboard');
              }
            })
            .catch(error => {
                console.log(error);
                this.error = error.messages;
                console.log(error.success);
                this.loading = false;
            }); 
          }else{
            this.loading = true;

            var dob = this.formatDate(this.date);
            this.user.data.date_of_birth = dob;
            this.user.data.title = this.title.text;
            this.user.data.nationality = this.nationality.name;

            const client = {
              email: this.user.data.email_address,
              first_name: this.user.data.first_name,
              last_name: this.user.data.last_name,
              other_names: "",
              title: this.title.text,
              gender: this.user.data.gender,
              marital_status: this.user.data.marital_status,
              nationality: this.nationality.name,
              dob: dob,
              phone_number: this.user.data.phone_number,
              residential_address: this.user.data.residential_address, 
              password: this.password,
              agency_id: 40,
              documents: [
                {
                  document_id: this.user.data.national_id,
                  document_type: this.user.data.id_type
                }
              ]
            }
            console.log(this.user);
            axios
            .post(URL, client)
            .then(response => {
              console.log(response);
              if (response.data.message == "success"){
                //this.$store.dispatch("fetchUser", response.data.client);
                this.user.loggedIn = true;
                this.user.newClient = true;
                this.user.data.user_id = response.data.client.user_id;
                this.user.data.client_id = response.data.client.id;
                this.loading = false;
                this.$router.push('/dashboard');
              }
            })
            .catch(error => {
                console.log(error);
                this.error = error.messages;
                console.log(error.success);
                this.loading = false;
            }); 
          }
        }
      },
      getPhoneNumber(payload){
        this.user.data.phone_number = payload.formattedNumber;
      }
    },
    computed: {
      ...mapGetters({
        user: "user"
      }),
      computedDateFormatted () {
        var new_date = '';
        if (!this.user.loggedIn){
          new_date = this.formatDate(this.date);
        }else{
          new_date = this.formatDate(this.user.data.date_of_birth);
        }
        return new_date;
      },
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    created() {
      // get country list
      var COUNTRY_URL = `https://restcountries.eu/rest/v2/all`;

      axios
        .get(COUNTRY_URL)
        .then(response => {
          this.country_list = response.data;
        })
        .catch(error => {
          console.log('Error',error);
        });
    }
  }
</script>
